function ReportType({ title, selected, ...otherProps }) {
    return (
        <button { ...otherProps } className={`${selected ? 'text-buttonText bg-primaryColor hover:bg-primaryAccent' : 'bg-[#EAEAEA] text-[#212121]'} outline-none select-none rounded-lg px-6 py-[7px] font-semibold text-[14px] leading-[26px]`}>
            {title}
        </button>
    );
}

export default ReportType;
